import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=0587976a&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587976a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0587976a')) {
      api.createRecord('0587976a', component.options)
    } else {
      api.reload('0587976a', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=0587976a&scoped=true&", function () {
      api.rerender('0587976a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FyrwVAet4nt3/JS/comp/Voucher-Unit.vue"
export default component.exports